/**
 * Show the mobile/tablet Topbar (hamburger) whenever the Sidebar uses drawer
 * mode — viewport below Ant `lg` / ThemeSetting `TAB_SIZE` (992px).
 * xs/sm-only left a dead zone from md (768) through 991 where the sider
 * collapsed into a drawer but no toggle was rendered.
 *
 * @param {Partial<Record<'xs'|'sm'|'md'|'lg'|'xl'|'xxl', boolean>>} screens
 *   Ant Design `Grid.useBreakpoint()` map.
 */
export const shouldShowMobileTopbar = screens => screens?.lg !== true;
